module.exports = __webpack_public_path__ + "img/9788932023724.c9673bb9.jpg";